import { MatDialogConfig } from '@angular/material/dialog';
import { FLOATING_AI_DIALOG_BASE } from './floating-ai-dialog.config';

/** How big the review opens the first time; after that its last size and place are kept. */
export const CURA_FORM_REVIEW_DEFAULT_SIZE = { width: '92vw', height: '88vh' };

/**
 * The review dialog floats like the CURA chat: no backdrop, so the patient file stays usable
 * underneath for checking an answer against the record, and the pane can be dragged and
 * resized out of the way. `sizePos` is what the layout service remembers for it.
 */
export function curaFormReviewDialogConfig(
  fillId: string,
  sizePos: Pick<MatDialogConfig, 'width' | 'height' | 'position'>
): MatDialogConfig {
  return {
    ...FLOATING_AI_DIALOG_BASE,
    ...sizePos,
    // MatDialog caps a pane at 80vw unless told otherwise; a resizable pane sets its own width.
    maxWidth: '100vw',
    maxHeight: '100vh',
    data: { fillId },
    panelClass: ['cura-form-review-panel', 'floating-ai-dialog-panel', 'cura-window-panel'],
  };
}
